import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AuthGuardProps {
  children: ReactNode;
  requireAuth?: boolean;
  /** Cần ít nhất một trong các quyền này. */
  permissions?: readonly string[];
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ 
  children, 
  requireAuth = true,
  permissions
}) => {
  const { isAuthenticated, isLoading, user, can } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
        <p>Đang kiểm tra đăng nhập...</p>
      </div>
    );
  }

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Thiếu quyền của trang: về trang đầu tiên người dùng được phép
  if (permissions && isAuthenticated && !can(...permissions)) {
    return <Navigate to={user?.homePath || '/checkinout'} replace />;
  }

  // Trang đăng nhập khi đã đăng nhập: về trang đầu tiên được phép
  if (!requireAuth && isAuthenticated) {
    return <Navigate to={user?.homePath || '/checkinout'} replace />;
  }

  return <>{children}</>;
};

